import AI from './newrelic/ai';
import TDP from './newrelic/tdp';
import FSO from './newrelic/fso';
import DarkModeToggle from './newrelic/dark-mode-toggle';
import I18n from './newrelic/i18n';

export default {
  ai: AI,
  fso: FSO,
  tdp: TDP,
  'dark-mode-toggle': DarkModeToggle,
  i18n: I18n,
};
